var map = {
	"./abacus.svg": "71a0",
	"./alembic.svg": "6295",
	"./balance_scale.svg": "f0b3",
	"./blue_book.svg": "ba1f",
	"./books.svg": "7c0e",
	"./dna.svg": "db8c",
	"./judge.svg": "aa79",
	"./memo.svg": "b91b",
	"./orange_book.svg": "b80a",
	"./robot.svg": "ccdd",
	"./rocket.svg": "c528",
	"./scroll.svg": "9aba",
	"./star.svg": "52d9",
	"./uk.svg": "519e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a16";